/**
* 财务管理 供货对账单
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <div class="mt20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我供货的" name="first">
          <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.purchaser_seller_name" placeholder="输入商家名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.order_code" placeholder="输入单据编号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
              <el-button size="small" type="warning" @click="exportExcel()">导出</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="单据时间" width="135">
              </el-table-column>
              <el-table-column prop="bill_type_text" label="账单类型" width="80">
                <template slot-scope="scope">
                  <div plain style="color: #409EFF" v-if="scope.row.bill_type_text=='出账'">
                    {{scope.row.bill_type_text}}
                  </div>
                  <div plain style="color: #F56C6C" v-else>
                    {{scope.row.bill_type_text}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="source_code" label="单据编号" min-width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="supplier_seller_name" label="供应商名称" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="purchaser_seller_name" label="商家名称" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="order_amount" label="单据金额" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.order_amount}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="wait_allocate_amount" label="供应商待划拨金额" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.bill_type == '2501'">
                    <div>￥{{scope.row.refund_amount}}</div>
                  </div>
                  <div v-else>
                    <div>￥{{scope.row.wait_allocate_amount}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="allocated_amount" label="供应商已划拨金额" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.allocated_amount || scope.row.allocated_amount == 0">￥{{scope.row.allocated_amount}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="pay_name" label="支付类型" width="90">
              </el-table-column>
              <el-table-column prop="pay_status" label="结算状态" width="90">
                <template slot-scope="scope">
                  <div v-if="scope.row.pay_status==1">已结算</div>
                  <div v-else>未结算</div>
                </template>
              </el-table-column>
              <el-table-column prop="allocated_time" label="划拨时间" width="135" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="ref_bill_codes" label="关联账单编号" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="120">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="detail(scope.row.id)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-tab-pane>

        <!-- 给我供货 -->
        <el-tab-pane label="给我供货" name="second" v-if="agent_type=='2891'">
          <el-form :inline="true" :model="formInline1" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.supplier_seller_name" placeholder="输入供应商名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.order_code" placeholder="输入单据编号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search1">查询</el-button>
              <el-button size="small" type="warning" @click="exportExcel()">导出</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time_str" label="单据时间" width="135">
              </el-table-column>
              <el-table-column prop="bill_type_text" label="账单类型" width="80">
                <template slot-scope="scope">
                  <div plain style="color: #409EFF" v-if="scope.row.bill_type_text=='出账'">
                    {{scope.row.bill_type_text}}
                  </div>
                  <div plain style="color: #F56C6C" v-else>
                    {{scope.row.bill_type_text}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="source_code" label="单据编号" min-width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="purchaser_seller_name" label="供应商名称" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="supplier_seller_name" label="商家名称" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="order_amount" label="单据金额" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.order_amount}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="wait_allocate_amount" label="供应商待划拨金额" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.bill_type == '2501'">
                    <div>￥{{scope.row.refund_amount}}</div>
                  </div>
                  <div v-else>
                    <div>￥{{scope.row.wait_allocate_amount}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="allocated_amount" label="供应商已划拨金额" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.allocated_amount || scope.row.allocated_amount == 0">￥{{scope.row.allocated_amount}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="pay_name" label="支付类型" width="90">
              </el-table-column>
              <el-table-column prop="pay_status" label="结算状态" width="90">
                <template slot-scope="scope">
                  <div v-if="scope.row.pay_status==1">已结算</div>
                  <div v-else>未结算</div>
                </template>
              </el-table-column>
              <el-table-column prop="allocated_time" label="划拨时间" width="135" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="ref_bill_codes" label="关联账单编号" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="120">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="detail(scope.row.id)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 详情界面 -->
    <el-dialog title="对账单详情" :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="detailVisible" width="50%" center>
      <div class="billing_information">
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">单据编号</p>
            <span class="f14 color333">{{detailData.source_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">单据金额</p>
            <span class="f14 color333">{{detailData.order_amount||detailData.order_amount==0?'￥'+detailData.order_amount:''}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">供应商待划拨金额</p>
            <span class="f14 color333">{{detailData.wait_allocate_amount||detailData.wait_allocate_amount==0?'￥'+detailData.wait_allocate_amount:''}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">供应商已划拨金额</p>
            <span class="f14 color333">{{detailData.allocated_amount||detailData.allocated_amount==0?'￥'+detailData.allocated_amount:''}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">划拨时间</p>
            <span class="f14 color333">{{detailData.allocated_time}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">支付类型</p>
            <span class="f14 color333">{{detailData.pay_name}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">银联交易号</p>
            <span class="f14 color333">{{detailData.refund_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">支付时间</p>
            <span class="f14 color333">{{detailData.refund_time}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">退款单号</p>
            <span class="f14 color333">{{detailData.billNo}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">退款时间</p>
            <span class="f14 color333">{{detailData.pay_success_time}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">售后服务单号</p>
            <span class="f14 color333">{{detailData.service_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">关联账单编号</p>
            <span class="f14 color333">{{detailData.ref_bill_codes}}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {billRecordList, billRecordDetail, billRecordExcel, recordSupply, recordPurchase} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        detailVisible: false, //控制编辑页面显示与隐藏
        searchDate: '',
        searchDate1: '',
        detailData: {},
        formInline: {
          page: 1,
          rows: 10,
          order_code: "",
          begin_time: "",
          end_time: "",
          purchaser_seller_name: ""
        },
        formInline1: {
          page: 1,
          rows: 10,
          order_code: "",
          begin_time: "",
          end_time: "",
          supplier_seller_name: ""
        },
        listData: [], //用户数据
        listData1: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        productDate: '',//出厂日期
        validityDate: '',//有效期
        activeName: 'first',
        agent_type: localStorage.getItem('agent_type') || '2891'
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.getdata1(this.formInline1)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 我供货的-公司列表
      getdata(parameter) {
        this.loading = true
        recordSupply(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 给我供货-公司列表
      getdata1(parameter) {
        this.loading = true
        recordPurchase(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content.rows
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getdata1(this.formInline1)
      },
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getdata(this.formInline)
        } else if (tab.index == 1) {
          this.getdata1(this.formInline1)
        }
      },
      // 搜索事件
      search() {
        if (this.searchDate) {
          this.formInline.begin_time = timestampToDate(this.searchDate[0])
          this.formInline.end_time = timestampToDate(this.searchDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      // 搜索事件
      search1() {
        if (this.searchDate1) {
          this.formInline1.begin_time = timestampToDate(this.searchDate1[0])
          this.formInline1.end_time = timestampToDate(this.searchDate1[1])
        } else {
          this.formInline1.begin_time = ''
          this.formInline1.end_time = ''
        }
        this.formInline1.page = 1;
        this.getdata1(this.formInline1)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.purchaser_seller_name == cell.innerText || row.source_code == cell.innerText || row.supplier_seller_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      //显示详情界面
      detail: function (id) {
        this.detailVisible = true
        this.loading = true
        billRecordDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.detailData = res.content;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.detailVisible = false
      },
      //导出
      exportExcel() {
        billRecordExcel(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '对账单信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .userRole {
    width: 100%;
  }

  .flex_box {
    display: flex;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyReconciliation.vue